import { useIntl } from 'react-intl';

import { groupingMessages } from '../groupingMessages';

import type { GroupFamily } from '../../domain/grouping.types';

/** "N POIs" / "N Screens" / "N Areas" pill. */
export function GroupCountBadge({ count, family }: Readonly<{ count: number; family: GroupFamily }>) {
  const { formatMessage } = useIntl();
  return (
    <span className="groupsMenu__count">{formatMessage(groupingMessages.familyItemsCount, { count, family })}</span>
  );
}
